import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import FAQ from "./containers/FAQ";
import Terms from "./containers/Terms";
import Pro from "./containers/Pro";
import NotFound from "./containers/NotFound";

export default () =>
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/pro" component={Pro} />
    <Route path="/faq" component={FAQ} />
    <Route path="/terms" component={Terms} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;
